import MenuSimple from "../ui/menuSimple";
import forceUnleashed from '../../images/theForceUnleashed.jpg'
import fallenOrder from '../../images/fallenOrder.jpg';
import skywalkerSaga from '../../images/skywalkerSaga.jpg';
import outlaws from '../../images/outlaws.jpg';
import battlefront from '../../images/battlefront.png';
import jediSurvivor from '../../images/jediSurvivor.png';
import CardGrid from "../features/cardGrid";
import Footer from "../ui/footer";

const Videojuegos = ()=>{
    const info = [
        {
            sectionName: 'videojuegos',
            id: 0,
            image: forceUnleashed,
            text: "una historia secreta del aprendiz oculto de darth vader, enviado a cazar jedi sobrevivientes y a desatar el verdadero poder de la fuerza. entre misiones imperiales y decisiones peligrosas, el protagonista descubre que su destino podría cambiar el equilibrio entre el imperio y la rebelión.",
            side: "dark",
            title: "the force unleashed"
        },
        {
            sectionName: 'videojuegos',
            id: 1,
            image: skywalkerSaga,
            text: "un viaje a través de toda la saga de star wars contado con humor y acción. desde la amenaza fantasma hasta el ascenso de la primera orden, los héroes más icónicos reviven sus aventuras en un formato divertido, pero fiel al espíritu galáctico.",
            side: "light",
            title: "lego star wars: the skywalker saga"
        },
        {
            sectionName: 'videojuegos',
            id: 2,
            image: fallenOrder,
            text: "tras la orden 66, un joven padawan sobrevive ocultándose del imperio. mientras huye de los inquisidores, debe reconectar con la fuerza, enfrentar su pasado y decidir si volver a empuñar el sable láser en una galaxia que ya no cree en los jedi.",
            side: "light",
            title: "star wars jedi: fallen order"
        },
        {
            image: outlaws,
            sectionName: 'videojuegos',
            id: 3,
            text: "en una galaxia dominada por sindicatos criminales y el poder imperial, una forajida busca libertad realizando trabajos peligrosos, robos y alianzas inciertas. cada decisión puede llevarla más cerca de la gloria… o directo a una tumba espacial.",
            side: "dark",
            title: "star wars outlaws"
        },
        {
            image: battlefront,
            sectionName: 'videojuegos',
            id: 4,
            text: "en plena guerra galáctica, soldados comunes viven el conflicto desde dentro del imperio y la rebelión. la historia muestra cómo la lealtad, la duda y la identidad chocan cuando un simple trooper comienza a cuestionar el sistema que juró defender.",
            side: "dark",
            title: "star wars battlefront ii"
        },
        {

            id: 5,
            sectionName: 'videojuegos',
            image: jediSurvivor,
            text: "la lucha continúa para un jedi perseguido por el imperio. más fuerte pero también más marcado por la guerra, debe proteger a sus aliados, explorar antiguos secretos de la fuerza y enfrentar la oscuridad que amenaza con consumirlo.",
            side: "light",
            title: "star wars jedi: survivor"
        }


    ];
    return(
        <>
            <MenuSimple />
            <CardGrid info={info} />
            <Footer />
        </>
    )
}

export default Videojuegos